import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 3.25a.75.75 0 0 1 .75.75v16a.75.75 0 0 1-1.5 0V4A.75.75 0 0 1 3 3.25M6.25 6A.75.75 0 0 1 7 5.25h8a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 6M7 9.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5zM6.25 14a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75M7 17.25a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5z"
    }, null, -1)
  ])))
}
export default { render: render }